import AccAccount from '@/models/Accounting/AccAccount'
import AccAccountingSeatStatus from '@/models/Accounting/AccAccountingSeatStatus'
import UserModel from '@/models/General/GUser'
export default [
    {
        name: 'acc_account_id',
        props: {
            hideDetails: true,
            label: 'Cuenta',
            model: AccAccount,
            itemText: 'comment',
            itemValue: 'id',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    {
        name: 'g_generator_user_id',
        props: {
            hideDetails: true,
            label: 'Responsable',
            model: UserModel,
            itemText: 'hr_employee.name_case',
            itemValue: 'id',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    {
        name: 'acc_accounting_seat_status_id',
        props: {
            hideDetails: true,
            label: 'Estado',
            model: AccAccountingSeatStatus,
            itemText: 'status',
            itemValue: 'id',
            paramSearch: 'status',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    // {
    //     name: 'acc_accounting_seat_status',
    //     props: {
    //         hideDetails: true,
    //         label: 'Estado',
    //         model: GState,
    //         itemText: 'state',
    //         itemValue: 'id',
    //         paramSearch: 'state',
    //         paramFilter: {
    //             g_state_type_id: 8,
    //         },
    //     },
    //     type: 'autocomplete-model',
    //     value: '',
    // },
    // {
    //     field: 'acc_account_id',
    //     value: [],
    //     label: 'Cuenta',
    //     type: '',
    // },
    // {
    //     field: 'g_generator_user_id',
    //     value: [],
    //     label: 'Responsable',
    //     type: '',
    // },
    // {
    //     field: 'acc_accounting_seat_status_id',
    //     value: [],
    //     label: 'Estado',
    //     type: '',
    // },
]
